module.exports = __webpack_public_path__ + "media/images/welcome-container-background-a106b480a314e1c3266d97e9f5ba52f7.png";